// Constants to be used as content for the associated component's `console.error` or `console.warn`.
export var MESSAGES = {
    MISSING_HEADER: 'Dialog requires a `Dialog.Header` child component.',
};
